var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger-button xl:hidden flex",class:{ active: _vm.active },on:{"click":_vm.toggleMenu}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }